export default __webpack_public_path__ + "static/media/corporate2.1f2c1507.png";